<template>
	<DividerAutoDirection>{{ $t('base-stations-edit.fields.coordDivider') }}</DividerAutoDirection>
	<Row>
		<Col span="24" :lg="{ span: 12 }">
			<RadioGroupWithTooltip
				v-model="antReferencePoint"
				:options="formSettings.antReferencePoints"
				:validateInfo="validateInfos.antReferencePoint"
				prefix="base-stations-edit.fields.antReferencePoint"
				small
			/>
		</Col>
	</Row>
	<Row>
		<Col span="24" :lg="{ span: 12 }">
			<FormItem :label="$t('base-stations-edit.fields.xCoord')" v-bind="validateInfos.xCoord">
				<InputDecimal v-model="xCoord" />
			</FormItem>
			<FormItem :label="$t('base-stations-edit.fields.yCoord')" v-bind="validateInfos.yCoord">
				<InputDecimal v-model="yCoord" />
			</FormItem>
			<FormItem :label="$t('base-stations-edit.fields.zCoord')" v-bind="validateInfos.zCoord">
				<InputDecimal v-model="zCoord" />
			</FormItem>
		</Col>
		<Col span="24" :lg="{ span: 12 }">
			<FormItem v-if="formState.bCoord != null" :label="$t('base-stations-edit.fields.bCoord')">
				<span class="pd-sm-x">{{ bCoordDisplay }}</span>
			</FormItem>
			<FormItem v-if="formState.lCoord != null" :label="$t('base-stations-edit.fields.lCoord')">
				<span class="pd-sm-x">{{ lCoordDisplay }}</span>
			</FormItem>
			<FormItem v-if="formState.hCoord != null" :label="$t('base-stations-edit.fields.hCoord')">
				<span class="pd-sm-x">{{ hCoordDisplay }} {{ $t('base-stations-edit.fields.hCoordUnit') }}</span>
			</FormItem>
			<FormItem v-if="mapLink" :label="$t('base-stations-edit.fields.mapLink')">
				<router-link class="pd-sm-x" :to="mapLink">{{ mapLink.fullPath }}</router-link>
			</FormItem>
		</Col>
	</Row>
</template>

<script>
import { toRef, computed } from 'vue';
import { Row, Col, FormItem } from 'ant-design-vue';

import InputDecimal from '@/components/common/InputDecimal.vue';
import RadioGroupWithTooltip from '@/components/forms/RadioGroupWithTooltip.vue';
import DividerAutoDirection from '@/components/common/DividerAutoDirection.vue';

import { useRouter } from 'vue-router';

import { hasCoords } from '@/utils/baseStationsUtils';
import { useSubformFieldProxies } from '@/components/addBaseStation/useSubformFieldProxies';


export default {
	components: { Row, Col, FormItem, InputDecimal, RadioGroupWithTooltip, DividerAutoDirection },
	emits: ['updateFormState'],
	props: ['formState', 'baseStationDetails', 'validateInfos', 'formSettings'],
	setup(props, { emit }) {
		const proxies = useSubformFieldProxies(props.formState, ['antReferencePoint', 'xCoord', 'yCoord', 'zCoord'], emit);
		const baseStationDetailsRef = toRef(props, 'baseStationDetails');
		const router = useRouter();
		const mapLink = computed(() => {
			const focusedMountpoint = props.formState.mntpntInt || props.formState.mntpntSrc;
			if (hasCoords(baseStationDetailsRef.value) && focusedMountpoint) {
				return router.resolve({ name: 'bs-on-map', params: { focusedMountpoint } });
			}
			return null;
		});
		const bCoordDisplay = computed(() => `${Number(props.formState.bCoord).toFixed(9)}°`);
		const lCoordDisplay = computed(() => `${Number(props.formState.lCoord).toFixed(9)}°`);
		const hCoordDisplay = computed(() => Number(props.formState.hCoord).toFixed(3));
		return {
			...proxies,
			mapLink,
			bCoordDisplay,
			lCoordDisplay,
			hCoordDisplay,
		}
	}
}
</script>
